import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { arrayMoveImmutable } from 'array-move';
import { connect, useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { saveCard, updateCard } from '../skill_builder/steps/CardActions';
import {
  cardInfo,
  slackInfo,
  handleSortListData,
  handleReportOptions,
  setInitialSortListData,
} from './report_actions';
import axios from 'axios';

import {
  Input,
  Typography,
  Select,
  Layout,
  message,
  Button,
  Tooltip,
} from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import { getJiraProjectStatues } from '../skills_action';
import ChartPreivew from './highChartPreview';

import {
  burnDownChart,
  createBarGraph,
  createCustomChart,
  velocityGraphJira,
} from './handleGraph';
import SlackSelect from '../../common/slackUserSelect';
const { Text } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const AppearancePage = (props) => {
  const dispatch = useDispatch();
  let sourceData = props.report.cardInfo;
  // console.log('there', sourceData)
  let key = props.template && props.template.key;
  const slackData = useSelector((state) => state.report.slackData);
  const issueCardConfig = useSelector((state) => state.report.issueCardInfo);

  const [slackmsg, setslackmsg] = useState(slackData && slackData.slack_msg);
  const [isLoadingActive, setIsLoadingActive] = useState(true);
  // const [reportOptions, setReportOptions] = useState({});
  const reportOptionsData = useSelector((state) => state.report.reportOptions);
  const [reportOptions, setReportOptions] = useState({});

  const [dataSource, setDataSource] = useState([]);

  //   useEffect(()=>{
  // // if(reportOptions && reportOptions.chart && reportOptions.chart.type && reportOptions.chart.type === 'summary')
  // setIsLoadingActive(true)
  //     setTimeout(()=>setIsLoadingActive(false), 300)
  //   },[props.reportType])
  // console.log(reportOptions && reportOptions.chart && reportOptions.chart.type && reportOptions.chart.type, props.reportType, sourceData.report_type)
  //   useEffect(()=>{
  //     // setIsLoadingActive(true)
  // if(reportOptionsData) {
  //   let updated_chartData = handleChartTheme(reportOptions);
  //       setReportOptions(updated_chartData)
  //   // setReportOptions(reportOptionsData)
  // }
  // // setIsLoadingActive(false)
  //   }, [reportOptionsData])

  const [data, setData] = useState({});

  const [allProjectData, setAllProjectData] = useState();
  const [jiraData, setJiraData] = useState();

  const [allowNext, setAllowNext] = useState(false);
  const [hiddenFields, setHiddenFields] = useState([]);
  const [noDataFound, setNoDataFound] = useState(false);

  const [timeout, setTIMEOUT] = useState(0);

  const sortListData = useSelector((state) => state.report.sortListData);
  const appearanceData = useSelector((state) => state.report.appearanceData);

  useEffect(() => {
    // console.log('setting loading true')
    setIsLoadingActive(true);
    // if (sortListData && sortListData.isLoadingActive){
    // }
    // setIsLoadingActive(false)
    setTimeout(() => setIsLoadingActive(false), 1);
  }, [sortListData]);

  useEffect(() => {
    // console.log('setting loading false')
    // setIsLoadingActive(false)
  }, [appearanceData]);

  useEffect(() => {
    setIsLoadingActive(true);
    setReportOptions(null);
    let cancelTokenSource = axios.CancelToken.source();
    // console.log('SourceData changed' ,key, sourceData)

    // cancelTokenSource.cancel('Request canceled by cleanup')
    if (sourceData) {
      setData(sourceData);
      // console.log('================================', sourceData);
      if (
        (((key && key == 'custom_report_2') ||
          (key && key == 'jira_count_graph')) &&
          sourceData.projects &&
          sourceData.projects.length > 0 &&
          sourceData.hasOwnProperty('y-axis-field') &&
          sourceData.hasOwnProperty('x-axis-field')) ||
        (sourceData.jql &&
          sourceData.hasOwnProperty('y-axis-field') &&
          sourceData.hasOwnProperty('x-axis-field') &&
          key &&
          key !== 'jira_burn_down_chart' &&
          key &&
          key !== 'jira_velocity_chart')
      ) {
        getIssuesDataForChart(cancelTokenSource);
      } else if (
        (sourceData.boardId &&
          sourceData.field &&
          key &&
          key == 'jira_burn_down_chart') ||
        (key &&
          key == 'jira_velocity_chart' &&
          sourceData.boardId &&
          sourceData.velocity_estimation)
      ) {
        // console.log('burndown and Velo api')
        getJiraDataForBurnDownAndVelocityChart(cancelTokenSource);
      } else if (
        (sourceData.jql && sourceData.listFilterType) ||
        (sourceData.custom_jql && sourceData.listFilterType)
      ) {
        getIssueDataForListReport(cancelTokenSource);
      }
    }
    validateFields();

    // cancelTokenSource = axios.CancelToken.source()
    return () => {
      // message.error('Request canceled by cleanup')
      cancelTokenSource.cancel('Request canceled by cleanup');
    };
  }, [
    sourceData.jql,
    sourceData.projects,
    sourceData.custom_jql,
    sourceData['x-axis-field'],
    sourceData['y-axis-field'],
    sourceData.field,
    sourceData.boardId,
    sourceData.number_field_type,
    sourceData.velocity_estimation,
    sourceData.mentions,
    sourceData.slackUsers,

    issueCardConfig,
    key,
  ]);

  useEffect(() => {
    // console.log('\nREPORT CHANGED', props.basicReportData && props.basicReportData.reportType);
    if (props.type == 'chart') {
      let chartData;
      if (
        props.basicReportData &&
        (props.basicReportData.reportType == 'burn' ||
          props.basicReportData.reportType == 'velocity')
      ) {
        // setIsLoadingActive(true);
      }
      chartData = { ...reportOptions };
      let updated_chartData = handleChartTheme(chartData);
      // console.log('report options and updated_chartData',updated_chartData, reportOptions)
      setReportOptions(updated_chartData);
      // dispatch(handleReportOptions(updated_chartData))
      // setIsLoadingActive(false);
      // setTimeout(()=>setIsLoadingActive(false), 100)
      validateFields();
    }
    if (props.reportType) sourceData.report_type = props.reportType;
  }, [
    sourceData.report_theme,
    props.basicReportData && props.basicReportData.reportType,
    props.basicReportData && props.basicReportData.name,
    hiddenFields,
  ]);

  useEffect(() => {
    setReportOptions(null);
    dispatch(handleReportOptions({}));
    setDataSource([]);
    setIsLoadingActive(true);
    setJiraData();
    setAllProjectData();
    setTimeout(() => setIsLoadingActive(false), 300);
  }, [key]);

  useEffect(() => {
    if (slackData && slackData.slack_msg) setslackmsg(slackData.slack_msg);
  }, [slackData && slackData.slack_msg]);

  const getIssuesDataForChart = (cancelTokenSource) => {
    let field;
    let meta = sourceData;

    let x_axis_field = meta['x-axis-field'];
    let y_axis_field = meta['y-axis-field'];

    if (meta.number_field && meta.number_field) {
      y_axis_field = meta.number_field.split('.');
      // y_axis_field.shift();
      y_axis_field = y_axis_field.join('.');
    }
    let x_field = x_axis_field && x_axis_field.split('.')[2];
    let y_field = y_axis_field && y_axis_field.split('.')[2];
    field = `${x_field},${y_field}`;
    axios
      .post(
        `/bot/api/w/${props.match.params.wId}/jira/getIssuesData`,
        {
          jql: sourceData.jql || sourceData.custom_jql,
          field: field,
          skill: props.report.cardInfo,
        },
        {
          cancelToken: cancelTokenSource.token, // Pass the cancel token to the request
        }
      )
      .then((res) => {
        if (res && res.data && res.data.data) {
          if (res.data.data && res.data.data.issueArr.length < 1)
            message.warning('No issues found');
          setAllProjectData(res.data.data);
          if (
            (sourceData.projects && sourceData.projects.length > 0) ||
            sourceData.jql
          ) {
            handleBarGraph(res.data.data);
          }
        } else {
        }
        setIsLoadingActive(false);
      })
      .catch((error) => {
        // message.success('Request canceled:', error.message)
        // if (axios.isCancel(error)) {
        //   // Request was canceled
        //   // console.log('Request canceled:', error.message);
        // }
        setIsLoadingActive(false);
      });
  };

  const validateFields = () => {
    if (key) {
      if (key === 'jira_burn_down_chart') {
        let allowNext = sourceData.boardId && sourceData.field;

        setAllowNext(allowNext);
      } else if (key === 'jira_velocity_chart') {
        let allowNext = sourceData.boardId && sourceData.velocity_estimation;
        setAllowNext(allowNext);
      } else if (key === 'jira_count_graph') {
        let allowNext =
          sourceData.filterType == 'Basic Filter'
            ? sourceData.projects &&
              sourceData.projects.length > 0 &&
              sourceData['y-axis-field'] &&
              sourceData['x-axis-field']
            : sourceData.jql &&
              sourceData['y-axis-field'] &&
              sourceData['x-axis-field'];
        setAllowNext(allowNext);
      } else if (key === 'custom_report_2') {
        let allowNext = null;

        if (sourceData['y-axis-field'] !== 'issues.fields.issue_count') {
          allowNext = allowNext =
            sourceData.jql &&
            sourceData['y-axis-field'] &&
            sourceData['x-axis-field'] &&
            sourceData.number_field_type;
        } else
          allowNext =
            sourceData.filterType == 'Basic Filter'
              ? sourceData.projects &&
                sourceData.projects.length > 0 &&
                sourceData['y-axis-field'] &&
                sourceData['x-axis-field']
              : sourceData.jql &&
                sourceData['y-axis-field'] &&
                sourceData['x-axis-field'];

        setAllowNext(allowNext);
      } else if (key === 'get_issues_by_jql') {
        let allowNext = sourceData.listFilterType && sourceData.jql;
        setAllowNext(allowNext);
      }
    }
  };
  const handleChartTheme = (chartData) => {
    if (
      sourceData &&
      sourceData.report_theme === 'dark' &&
      // sourceData.report_theme === 'default') &&
      chartData
    ) {
      chartData.chart = {
        ...chartData.chart,
        backgroundColor: '#1e1e1e',
      };

      if (chartData.xAxis && chartData.xAxis.gridLineColor) {
        chartData.xAxis.gridLineColor = '#1e1e1e';
        chartData.xAxis.lineWidth = 1;
        chartData.xAxis.lineColor = 'rgba(255, 255, 255, 0.25)';
      }

      if (chartData.yAxis && chartData.yAxis.gridLineColor) {
        chartData.yAxis.gridLineColor = '#1e1e1e';
        chartData.yAxis.lineWidth = 1;
        chartData.yAxis.lineColor = 'rgba(255, 255, 255, 0.25)';
      }

      if (
        (props.reportType && props.reportType == 'summary') ||
        props.reportType == 'list' ||
        props.reportType == 'burn' ||
        props.reportType == 'velocity'
      ) {
        // chartData.chart.type = '';
      } else {
        // chartData.chart.type = sourceData && sourceData.report_type;
        chartData.chart.type = props.reportType;
      }

      if (chartData.title) {
        chartData.title.text =
          props.basicReportData && props.basicReportData.name;

        if (chartData.title && chartData.title.style) {
          chartData.title.style.color = '#EFEFEF';
        }
      }

      if (chartData.subtitle && chartData.subtitle.style) {
        chartData.subtitle.style.color = '#ccc';
      }

      if (chartData.legend && chartData.legend.itemStyle) {
        chartData.legend.itemStyle.color = '#ccc';
      }
    } else if (chartData) {
      chartData.chart = {
        ...chartData.chart,
        backgroundColor: '#ffffff',
      };
      if (chartData.xAxis && chartData.xAxis) {
        chartData.xAxis.gridLineColor = '#ffffff';
        chartData.xAxis.lineWidth = 1;
        chartData.xAxis.lineColor = 'rgba(0, 0, 0, 0.25)';
      }
      if (chartData.yAxis && chartData.yAxis) {
        chartData.yAxis.gridLineColor = '#ffffff';
        chartData.yAxis.lineWidth = 1;
        chartData.yAxis.lineColor = 'rgba(0, 0, 0, 0.25)';
      }
      if (
        (sourceData.report_type && sourceData.report_type == 'summary') ||
        sourceData.report_type == 'list' ||
        sourceData.report_type == 'burn' ||
        sourceData.report_type == 'velocity'
      ) {
        // chartData.chart.type = '';
      } else {
        chartData.chart.type = sourceData && sourceData.report_type;
      }

      if (chartData.title)
        chartData.title.text =
          /* 
          (sourceData && sourceData.report_name) ||
          (props.report &&
            props.report.card_template_id &&
            props.report.card_template_id.name); */
          props.basicReportData && props.basicReportData.name;

      if (chartData.title && chartData.title.style) {
        chartData.title.style.color = '#101010';
      }

      if (chartData.subtitle && chartData.subtitle.style) {
        chartData.subtitle.style.color = '#ccc';
      }

      if (chartData.legend && chartData.legend.itemStyle) {
        chartData.legend.itemStyle.color = '#ccc';
      }

      // chartData.title.style.color = 'black';
      // chartData.subtitle.style.color = 'grey';
      // chartData.legend.itemStyle.color = 'grey';
    }

    chartData.plotOptions = {
      series: {
        borderRadius: {
          radius: 2,
        },
      },
      column: {
        dataLabels: {
          enabled: true,
          style: {
            fontSize: 8,
            color: sourceData.report_theme == 'dark' ? '#FFFFFFD9' : '#000000',
          },
        },
        borderWidth: 0,
      },
    };
    return chartData;
  };
  const getJiraDataForBurnDownAndVelocityChart = (cancelTokenSource) => {
    if (props.template && props.template.key) {
      axios
        .post(
          `/bot/api/w/${props.match.params.wId}/jira/getJiraData`,
          {
            // Pass the cancel token to the request

            meta: sourceData,
            key: props.template && props.template.key,
          },
          {
            cancelToken: cancelTokenSource.token,
          }
        )
        .then((res) => {
          // console.log('JIRA DATA',res)
          setIsLoadingActive(false);
          if (res && res.data && res.data.success) {
            setNoDataFound(false);
            setJiraData(res.data);
            if (
              props.template.key === 'jira_burn_down_chart' &&
              res.data &&
              sourceData &&
              sourceData.field &&
              sourceData.board
            ) {
              handleBurnDownChart(res.data);
            }
            if (
              props.template.key === 'jira_velocity_chart' &&
              sourceData.boardId
            ) {
              handleVelocityChart(res.data);
            }
          } else {
            message.warning('No data found in Jira');
            setNoDataFound(true);
          }
        })
        .catch((err) => {
          setIsLoadingActive(false);
        });
    }
  };

  const getIssueDataForListReport = (cancelTokenSource) => {
    let fieldDetailed =
      issueCardConfig &&
      issueCardConfig.fieldsSelectedDetailed &&
      issueCardConfig.fieldsSelectedDetailed.map((f) => f.key).join(',');
    let fieldCompact =
      issueCardConfig &&
      issueCardConfig.fieldSelectedCompact &&
      issueCardConfig.fieldSelectedCompact.key;

    axios
      .post(
        `/bot/api/w/${props.match.params.wId}/jira/getIssuesData`,
        {
          jql: sourceData.jql,
          field: 'summary,' + fieldDetailed + ',' + fieldCompact,
          skill: props.report.cardInfo,
        },
        {
          cancelToken: cancelTokenSource.token,
        }
      )
      .then((res) => {
        if (res && res.data && res.data.success) {
          setNoDataFound(false);
          setAllProjectData(res.data.data);
          setIsLoadingActive(false);
          if (res.data.data && res.data.data.issueArr.length < 1) {
            setNoDataFound(true);
            message.warning('No issues found');
          }
        } else {
          message.warning(
            res.data.message && res.data.message.err === 'limit_exceeded'
              ? `Maximum JIRA issue limit (${
                  res.data.message.count || 2000
                }) exceeded for report.`
              : res.data.message.message
              ? res.data.message.message.split(':')[0].trim()
              : res.data.message
          );
          setIsLoadingActive(false);
          setAllProjectData({});
          setNoDataFound(true);
        }
      })
      .catch((err) => {
        setIsLoadingActive(false);
      });
  };

  const handleBarGraph = (resData) => {
    let xAxis =
      sourceData &&
      sourceData['x-axis-field'] &&
      sourceData['x-axis-field'].split('.').slice(1, 5).join('.');
    let chartData;
    if (
      sourceData &&
      sourceData['y-axis-field'] &&
      sourceData['y-axis-field'].split('.')[2] == 'issue_count'
    ) {
      chartData = createBarGraph(
        resData.issueArr,
        {
          ...sourceData,
          x_axis: xAxis,
        },
        props.report.template,
        props.isEditMode
      );
    } else {
      let y_axis = sourceData['y_axis_field'];
      if (sourceData.number_field && sourceData.number_field) {
        y_axis = sourceData.number_field.split('.');
        y_axis.shift();
        y_axis = y_axis.join('.');
      }

      chartData = createCustomChart({
        meta: sourceData,
        issueArr: resData.issueArr,
        x_axis_field: xAxis,
        y_axis_field: y_axis,
        skill: props.report.template,
      });
    }
    let dataSource1 = [];
    let chartDataArr =
      chartData && chartData.dataArray && chartData.dataArray[0].data;
    if (chartDataArr) {
      let hidden_fields = [];
      if (sourceData.hasOwnProperty('appearanceData')) {
        let newDataArr = chartDataArr
          .map((item) => {
            let modifiedData =
              Array.isArray(sourceData.appearanceData) &&
              sourceData.appearanceData.find(
                (data) =>
                  parseInt(data.id) == parseInt(item.id) || data.id == item.id
              );
            if (modifiedData) {
              if (modifiedData.color) {
                item.color = modifiedData.color;
              }
              if (modifiedData.isHidden) {
                item.isHidden = true;
              }
              // else item.isHidden =false;
              if (modifiedData.updatedName) {
                item.updatedName = modifiedData.updatedName;
              }
              item.position = modifiedData.position;
              // item.isHidden = modifiedData.isHidden

              // item = modifiedData;
            }
            if (item.isHidden) hidden_fields.push(item);
            return item;
          })
          .filter((data) => data && !data.isHidden)
          .sort((a, b) => a.position - b.position);
        setHiddenFields(hidden_fields);
        chartDataArr = newDataArr;
        // dispatch(handleSortListData({...sortListData, hiddenFields:hidden_fields}))
      }
      dispatch(
        handleSortListData({
          ...sortListData,
          dataSource: chartDataArr,
          hiddenFields: hidden_fields,
        })
      );
      dispatch(
        setInitialSortListData({
          ...sortListData,
          dataSource: chartDataArr,
          hiddenFields: hidden_fields,
        })
      );
      setDataSource(chartDataArr);
    } else setDataSource([]);
    let column_options = {
      chart: {
        type:
          (sourceData.report_type && sourceData.report_type == 'summary') ||
          sourceData.report_type == 'list' ||
          sourceData.report_type == 'burn' ||
          sourceData.report_type == 'velocity'
            ? ''
            : sourceData.report_type,

        // Edit chart spacing
        backgroundColor:
          sourceData && sourceData.report_theme == 'dark' /*  ||
          sourceData.report_theme == 'default' */
            ? '#1e1e1e'
            : '#ffffff',
        spacingBottom: 25,
        spacingTop: 20,
        spacingLeft: 10,
        marginRight: 25,
        // Explicitly tell the width and height of a chart
        width: 350,
        height: 250,
        borderWidth: 4,
        borderRadius: 2,
        borderColor: {
          linearGradient: [0, 0, 0, 500, 500, 500],
          stops: [
            [0, 'rgba(255, 217, 192, 1)'],
            [1, 'rgba(253, 201, 240, 1)'],
            [2, 'rgba(209, 228, 255, 1)'],
          ],
          // linearGradient : [0,0,300,300],
          // stops:[
          //   [0,'rgba(253, 127, 146, 1)'],
          //   [1,'rgba(253, 195, 172, 1)']
          // ]
        },
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
      style: {
        fontFamily: 'Inter',
      },
      title: {
        text:
          (props.basicReportData && props.basicReportData.name) ||
          (sourceData && sourceData.report_name) ||
          (props.report &&
            props.report.template.name &&
            props.report.template.name) ||
          (props.report &&
            props.report.card_template_id &&
            props.report.card_template_id.name),
        style: {
          color: sourceData.report_theme == 'dark' ? '#EFEFEF' : '#FFFFFF',
          fontSize: 12,
        },
      },

      subtitle: {
        text: '',
        style: {},
      },
      plotOptions: {
        series: {
          // borderRadius: 10,

          borderRadius: {
            where: 'end',
            radius: 2,
          },
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            style: {
              fontSize: 8,
              shape: null,
              align: 'top',
              color:
                sourceData.report_theme == 'dark' ? '#FFFFFFD9' : '#000000',
            },
          },
        },
      },
      tooltip: {
        // headerFormat: '<b>{series.name}</b><br/>',
        pointFormat: '{point.y}',
      },
      series: [
        {
          // name:'',
          data: [...chartDataArr],
          showInLegend: false,
          lineColor: '#666',
          // lineWidth: 3,
          color: '#B399FE',
          // enableMouseTracking: false,

          // borderRadius: {

          //   where:'end',
          //   radius: 10,
          // },

          // marker: {
          //   radius: 5,
          //   lineColor: '#666',
          //   fillColor: '#666',
          // },
          // color: sourceData.report_theme == 'dark' ? '#EFEFEF' : '#FFFFFF',
        },
      ],
      // plotOptions: {
      //   // series: {
      //   //   borderWidth: 0,
      //   //   borderRadius: '50px',
      //   // },
      //   column: {
      //     dataLabels: {
      //       enabled: true,
      //       style: {
      //         fontFamily: 'Inter',
      //         fontSize: 8,
      //         color:
      //           sourceData.report_theme == 'dark' ? '#FFFFFFD9' : '#000000',
      //       },
      //     },
      //     borderWidth: 0,
      //     // borderRadius: '50%',

      //     width: 1,
      //     // enableMouseTracking: false,
      //   },
      // },

      legend: {
        itemStyle: {},
      },

      xAxis: {
        title: {
          text:
            chartData &&
            (chartData.x_axis_name ||
              (chartData.x_axis_info &&
                chartData.x_axis_info.title &&
                chartData.x_axis_info.title.text)),
          style: {
            fontSize: 8,
          },
          distance: 0,

          // align: 'high',
        },
        lineColor:
          sourceData && sourceData.report_theme == 'dark'
            ? 'rgba(255, 255, 255, 0.25)'
            : 'rgba(0, 0, 0, 0.25)',
        lineWidth: 1,
        labels: {
          distance: 5,
          style: {
            fontSize: 8,
            color: 'grey',
          },
        },
        gridLineColor:
          sourceData && sourceData.report_theme == 'dark' /* ||
          sourceData.report_theme == 'default' */
            ? '#1e1e1e'
            : '#ffffff',
        categories:
          chartDataArr &&
          chartDataArr.map((d) =>
            d && d.updatedName ? d.updatedName : d && d.name
          ),
      },

      yAxis: {
        // min: 0,
        title: {
          text: chartData && chartData.y_axis_name,
          style: {
            fontSize: 8,
          },
          distance: 0,

          // align: 'high',
        },

        labels: {
          overflow: 'justify',
          padding: 0,
          distance: 5,
          style: { fontSize: 8, padding: 0, color: 'grey', align: 'left' },
        },
        gridLineColor:
          sourceData && sourceData.report_theme == 'dark'
            ? /* ||
          sourceData.report_theme == 'default' */
              '#1e1e1e'
            : '#ffffff',
        lineColor:
          sourceData && sourceData.report_theme == 'dark'
            ? 'rgba(255, 255, 255, 0.25)'
            : 'rgba(0, 0, 0, 0.25)',
        lineWidth: 1,
      },
    };

    if (props.type == 'chart') {
      setReportOptions(column_options);
      dispatch(handleReportOptions(column_options));
    }
    setIsLoadingActive(false);
  };

  // const drawChart = (
  //   type,
  //   bgColor,
  //   titleText,
  //   titleTextColor,
  //   data,
  //   xAxisData,
  //   yAxisTitle,
  //   theme
  // ) => {
  //   let column_options = {
  //     chart: {
  //       type: type,

  //       // Edit chart spacing
  //       backgroundColor: bgColor,

  //       spacingBottom: 10,
  //       // spacingTop: 10,
  //       spacingLeft: 0,
  //       // spacingRight: 10,
  //       // Explicitly tell the width and height of a chart
  //       width: 350,
  //       height: 250,
  //     },
  //     credits: {
  //       enabled: false,
  //     },
  //     exporting: {
  //       enabled: false,
  //     },
  //     style: {
  //       fontFamily: 'Inter',
  //     },
  //     title: {
  //       text: titleText,
  //       style: {
  //         color: titleTextColor,
  //         fontSize: 12,
  //       },
  //     },
  //     subtitle: {
  //       text: '',
  //       style: {},
  //     },
  //     plotOptions: {
  //       series: {
  //         borderRadius: 15,
  //         borderWidth: 5,
  //       },
  //     },
  //     series: [
  //       {
  //         data: data,
  //         showInLegend: false,
  //         lineColor: '#666',
  //         // lineWidth: 3,
  //         color: '#B399FE',

  //         // marker: {
  //         //   radius: 5,
  //         //   lineColor: '#666',
  //         //   fillColor: '#666',
  //         // },
  //         // color: sourceData.report_theme == 'dark' ? '#EFEFEF' : '#FFFFFF',
  //       },
  //     ],
  //     // plotOptions: {
  //     //   // series: {
  //     //   //   borderWidth: 0,
  //     //   //   borderRadius: '50px',
  //     //   // },
  //     //   column: {
  //     //     dataLabels: {
  //     //       enabled: true,
  //     //       style: {
  //     //         fontFamily: 'Inter',
  //     //         fontSize: 8,
  //     //         color:
  //     //           sourceData.report_theme == 'dark' ? '#FFFFFFD9' : '#000000',
  //     //       },
  //     //     },
  //     //     // borderWidth: 0,
  //     //     // borderRadius: '50%',

  //     //     width: 1,
  //     //     enableMouseTracking: false,
  //     //   },
  //     // },

  //     legend: {
  //       itemStyle: {},
  //     },

  //     xAxis: {
  //       // lineColor: '#ffffff',
  //       labels: {
  //         style: {
  //           fontSize: 8,
  //           color: 'grey',
  //         },
  //       },
  //       gridLineColor: theme && theme == 'dark' ? '#1e1e1e' : '#ffffff',
  //       categories: xAxisData,
  //     },

  //     yAxis: {
  //       // min: 0,
  //       title: {
  //         text: yAxisTitle,
  //         style: {
  //           fontSize: 8,
  //         },

  //         // align: 'high',
  //       },
  //       labels: {
  //         // overflow: 'justify',
  //         padding: 0,
  //         distance: 0,
  //         style: { fontSize: 8, padding: 0 },
  //       },
  //       gridLineColor: theme && theme == 'dark' ? '#1e1e1e' : '#ffffff',
  //     },
  //   };

  //   return column_options;
  // };

  const handleBurnDownChart = (jiraData) => {
    let chartData = burnDownChart(sourceData, jiraData).chartData;

    chartData.xAxis = {
      ...chartData.xAxis,
      lineColor:
        sourceData && sourceData.report_theme == 'dark'
          ? 'rgba(255, 255, 255, 0.25)'
          : 'rgba(0, 0, 0, 0.25)',
      distance: 5,
      title: {
        style: {
          fontSize: 8,
          margin: 2,
        },

        // align: 'high',
      },
      labels: {
        style: {
          fontSize: 8,
          color: 'grey',
        },
      },
    };

    chartData.yAxis = {
      ...chartData.yAxis,
      lineColor:
        sourceData && sourceData.report_theme == 'dark'
          ? 'rgba(255, 255, 255, 0.25)'
          : 'rgba(0, 0, 0, 0.25)',

      title: {
        style: {
          fontSize: 8,
          margin: 2,
        },

        // align: 'high',
      },
      labels: {
        // overflow: 'justify',
        // align: 'right',
        // x: -2,
        padding: 0,
        distance: 5,
        style: { fontSize: 8, padding: 0, color: 'grey' },
      },
    };
    // console.log('here is the  MAGICCCC', sourceData);
    if (sourceData.report_theme === 'dark') {
      chartData.chart = {
        ...chartData.chart,
        backgroundColor: '#1e1e1e',
        type: 'line',
      };
      chartData.title.style.color = '#EFEFEF';
      chartData.title.style.fontSize = 12;
      chartData.subtitle.style.color = '#ccc';
      chartData.legend.itemStyle.color = '#ccc';
    } else {
      chartData.chart = {
        ...chartData.chart,
        backgroundColor: '#ffffff',
        type: 'line',
      };
      chartData.title.style.color = '#ffffff';
      chartData.title.style.fontSize = 12;
      chartData.subtitle.style.color = '#ccc';
      chartData.legend.itemStyle.color = '#ccc';
    }
    // console.log('coming here \n\n ', chartData);
    setReportOptions(chartData);
    dispatch(handleReportOptions(chartData));
  };

  const handleVelocityChart = (jiraData) => {
    let velocityChartData = velocityGraphJira(sourceData, jiraData);
    let chartData = velocityChartData.options;
    // console.log('original chartData',velocityChartData)

    if (
      sourceData.report_theme === 'dark' /* ||
          sourceData.report_theme === 'default' */
    ) {
      chartData.chart = {
        spacingBottom: 25,
        spacingTop: 20,
        spacingLeft: 10,
        marginRight: 25,
        // Explicitly tell the width and height of a chart
        width: 350,
        height: 250,
        borderWidth: 4,
        borderRadius: 2,
        borderColor: {
          linearGradient: [0, 0, 0, 500, 500, 500],
          stops: [
            [0, 'rgba(255, 217, 192, 1)'],
            [1, 'rgba(253, 201, 240, 1)'],
            [2, 'rgba(209, 228, 255, 1)'],
          ],
        },
        backgroundColor: '#1e1e1e',
        type: 'column',
      };
    } else {
      chartData.chart = {
        spacingBottom: 25,
        spacingTop: 20,
        spacingLeft: 10,
        marginRight: 25,
        // Explicitly tell the width and height of a chart
        width: 350,
        height: 250,
        borderWidth: 4,
        borderRadius: 2,
        borderColor: {
          linearGradient: [0, 0, 0, 500, 500, 500],
          stops: [
            [0, 'rgba(255, 217, 192, 1)'],
            [1, 'rgba(253, 201, 240, 1)'],
            [2, 'rgba(209, 228, 255, 1)'],
          ],
        },
        backgroundColor: '#ffffff',
        type: 'column',
      };
    }
    chartData.title = {
      text: props.basicReportData && props.basicReportData.name,
      style: {
        color: sourceData.report_theme == 'dark' ? '#EFEFEF' : '#FFFFFF',
        fontSize: 12,
      },
    };

    chartData.style = {
      fontFamily: 'Inter',
    };
    chartData.xAxis = {
      ...chartData.xAxis,
      lineColor:
        sourceData && sourceData.report_theme == 'dark'
          ? 'rgba(255, 255, 255, 0.25)'
          : 'rgba(0, 0, 0, 0.25)',
      lineWidth: 1,
      labels: {
        distance: 5,
        style: {
          fontSize: 8,
          color: 'grey',
        },
      },
      gridLineColor:
        sourceData && sourceData.report_theme == 'dark' /* ||
          sourceData.report_theme == 'default' */
          ? '#1e1e1e'
          : '#ffffff',
    };

    chartData.yAxis = {
      ...chartData.yAxis,
      title: {
        ...chartData.yAxis.title,
        style: {
          fontSize: 8,
        },
        distance: 0,

        // align: 'high',
      },
      labels: {
        overflow: 'justify',
        padding: 0,
        distance: 5,
        style: { fontSize: 8, padding: 0, color: 'grey', align: 'left' },
      },
      gridLineColor:
        sourceData && sourceData.report_theme == 'dark'
          ? /* ||
        sourceData.report_theme == 'default' */
            '#1e1e1e'
          : '#ffffff',
      lineColor:
        sourceData && sourceData.report_theme == 'dark'
          ? 'rgba(255, 255, 255, 0.25)'
          : 'rgba(0, 0, 0, 0.25)',
      lineWidth: 1,
    };

    chartData.plotOptions = {
      series: {
        // borderRadius: 10,
        borderRadius: {
          where: 'end',
          radius: 2,
        },
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          style: {
            fontSize: 8,
            shape: null,
            align: 'top',
            color: sourceData.report_theme == 'dark' ? '#FFFFFFD9' : '#000000',
          },
        },
      },
      column: {
        dataLabels: {
          enabled: true,
          style: {
            fontSize: 8,
            color: sourceData.report_theme == 'dark' ? '#FFFFFFD9' : '#000000',
          },
        },
        borderWidth: 0,
      },
    };

    setReportOptions(chartData);
    dispatch(handleReportOptions(chartData));
  };

  const handleNextStep = () => {
    props.changeStep(1, data);
  };

  const handleChange = (value, type) => {
    // console.log(value,type)
    if (type === 'mentions') {
      setData({ ...sourceData, [type]: value });
      dispatch(cardInfo({ ...sourceData, [type]: value }));
    } else if (type == 'slackUsers') {
      setData({ ...sourceData, [type]: value });
      dispatch(cardInfo({ ...sourceData, [type]: value }));
    }
  };

  const handleCreateAndUpdate = () => {
    props.handleCreateReport();
  };

  const handleMessage = (e) => {
    setslackmsg(e.target.value);
    if (timeout) clearTimeout(timeout);
    setTIMEOUT(
      setTimeout(() => {
        dispatch(slackInfo({ ...slackData, slack_msg: e.target.value }));
      }, 300)
    );
  };
  return (
    <div style={{ overflow: 'scroll' }}>
      <div>
        <div style={{ marginBottom: 24 }}>
          <ChartPreivew
            type={
              (props.basicReportData &&
                props.basicReportData.reportType == 'list') ||
              (props.report &&
                props.report.cardInfo &&
                props.report.cardInfo.report_type == 'list')
                ? 'list'
                : 'chart'
            }
            reportType={
              (props.basicReportData && props.basicReportData.reportType) ||
              (props.report &&
                props.report.cardInfo &&
                props.report.cardInfo.report_type)
            }
            reportOptions={reportOptions}
            isLoadingActive={isLoadingActive}
            cardInfo={sourceData}
            dataSource={dataSource}
            jiraData={jiraData}
            allProjectData={allProjectData}
            sourceData={sourceData}
            allowNext={allowNext}
            slackmsg={slackmsg}
            key={key}
            skill_type={props.skill_type}
            noDataFound={noDataFound}
          />
        </div>
      </div>

      {props.skill_type == 'app_message' && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'right',
            marginTop: 8,
            marginBottom: 24,
            alignItems: 'center',
          }}
        >
          <div style={{ marginRight: 8 }}>
            <Text>Customise issue card</Text>
            <Tooltip title='Customise how issues will shown in slack'>
              <InfoCircleOutlined
                style={{
                  marginLeft: 8,
                  fontSize: 12,
                  color: 'rgba(0, 0, 0, 0.45)',
                }}
              />
            </Tooltip>
          </div>
          <Button
            onClick={() => {
              props.showCustomizeModal(true);
            }}
          >
            Customise
          </Button>
        </div>
      )}
      {/* )} */}

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: 8,
        }}
      >
        {/* <div style={{ display: 'flex', marginBottom: 16 }}>
          <Text style={{ width: 100 }}>Order by</Text>
         
          <Input
            id='reportOpeningMessage'
            placeholder='custom order'
            defaultValue='Custom Order'
            style={{ width: '70%', marginRight: 16 }}
          />
        </div> */}

        {/* <div>
          <div style={{ display: 'flex', marginBottom: 16 }}>
            <Text style={{ width: 100 }}>Background color</Text>
            
            <Button icon={<LineChartOutlined />}></Button>
            <Button icon={<LineChartOutlined />}></Button>
            <Button icon={<LineChartOutlined />}></Button>
            <Button icon={<LineChartOutlined />}></Button>
            <Button icon={<LineChartOutlined />}></Button>
            <Button icon={<LineChartOutlined />}></Button>
          </div>
        </div> */}

        {props && props.current == 0 ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: 4,
            }}
          ></div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div
              style={{
                display: 'flex',
                marginBottom: 16,
                alignItems: 'center',
              }}
            >
              <Text strong style={{ minWidth: '100px' }}>
                Message
              </Text>
              <TextArea
                name='slack_message'
                value={slackmsg}
                onChange={(e) => {
                  handleMessage(e);
                }}
                placeholder='Slack Message'
                rows={slackmsg && slackmsg.length > 50 ? 2 : 1}
              />
            </div>
          </div>
        )}

        {props &&
        props.current == 1 &&
        key &&
        key !== 'jira_burn_down_chart' &&
        key !== 'jira_velocity_chart' &&
        props.skill_type != 'app_home' ? (
          <>
            <div
              style={{
                display: 'flex',
                marginBottom: 16,
                alignItems: 'center',
              }}
            >
              <Text strong style={{ minWidth: 100 }}>
                Mention
              </Text>

              <Select
                showSearch
                allowClear={true}
                mode='multiple'
                autoClearSearchValue
                style={{ width: '100%' }}
                value={data && data.mentions ? data.mentions : []}
                onChange={(e) => handleChange(e, 'mentions')}
                placeholder='Select mention user field'
                name='project_id'
                filterOption={(input, option) => {
                  if (typeof option.props.children == 'string') {
                    return (
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  } else {
                    return (
                      option.props.label
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }
                }}
              >
                {props.userFields &&
                  props.userFields.map((field, index) => {
                    if (field)
                      return (
                        <Option
                          key={index}
                          name='x-axis-field'
                          value={field.id || field.key}
                        >
                          {field.name}
                        </Option>
                      );
                  })}
              </Select>
            </div>

            <div
              style={{
                display: 'flex',
                marginBottom: 16,
                alignItems: 'center',
              }}
            >
              <Text strong style={{ minWidth: 100 }}>
                User Mentions
              </Text>

              <SlackSelect
                wId={props.match.params.wId}
                type={'member'}
                style={{ width: '100%' }}
                allowClear={true}
                // defaultValue=""
                mode={'multiple'}
                dropdownClassName='sidebar_dropdown'
                defaultUsers={data && data.slackUsers ? data.slackUsers : []}
                // value={this.state.memberList._id && this.state.memberList.name}
                value={
                  data && data.slackUsers
                    ? data.slackUsers.map((u) => u.user_id || u)
                    : []
                }
                onChange={(e) => handleChange(e, 'slackUsers')}
                // onChange={this.onMemberChange}
              />
            </div>
          </>
        ) : (
          <></>
        )}
        {props && props.current == 0 && (
          <div>
            <Button
              type='primary'
              onClick={() => {
                props.skill_type == 'app_message'
                  ? handleNextStep()
                  : handleCreateAndUpdate();
              }}
              disabled={!allowNext}
              style={{ width: '100%' }}
            >
              {props.skill_type == 'app_message'
                ? 'Next'
                : props.isEditMode
                ? 'Update'
                : 'Create'}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    projects: state.skills.projects,
    fields: state.skill_builder.fields,
    boards: state.skills.jiraBoards,
    sourceData: state.skills.sourceData,
    report: state.report,
    cardInfo: state.report.cardInfo,

    isReRender: state.skills.isReRender,
  };
};
export default withRouter(
  connect(mapStateToProps, {
    saveCard,
    updateCard,
    getJiraProjectStatues,
  })(AppearancePage)
);
